import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import {
    RESPOND_LIST_CONNECTIONS,
    RESPOND_ADD_CONNECTION,
    RESPOND_UPDATE_CONNECTION,
    RESPOND_REMOVE_CONNECTION,
    RESPOND_SYNC_CONNECTION,
    RESPOND_LIST_CAMERAS,
    RESPOND_SYNC_SELECTED_CAMERAS,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/integration/milestoneMsgDefinitions";
import {
    MilestoneConnection,
    MilestoneConnectionHeader,
    MilestoneConnectionID,
    MilestoneCameraList,
} from "userful-chronos-app-common-js/dist/models/integration/milestone";
import integrationStore from "../integrationStore";
import { milestoneActions } from "../milestoneSlice";
import { registerErrorMsgHandlerByMsgDefinition } from "userful-chronos-app-common-js/dist/message/messageRegistery";

registerMsgHandler(RESPOND_LIST_CONNECTIONS, (payload) => {
    const data = JSON.parse(payload) as MilestoneConnection[];
    integrationStore.dispatch(milestoneActions.setConnections(data));
});

registerMsgHandler(RESPOND_ADD_CONNECTION, (payload) => {
    JSON.parse(payload) as MilestoneConnectionHeader;
    integrationStore.dispatch(milestoneActions.changeLoadState("RENDER"));
    integrationStore.dispatch(milestoneActions.setOpenForm(false));
    integrationStore.dispatch(milestoneActions.getConnectionsFromServer());
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_ADD_CONNECTION, () => {
    integrationStore.dispatch(milestoneActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_UPDATE_CONNECTION, (payload) => {
    JSON.parse(payload) as MilestoneConnectionHeader;
    integrationStore.dispatch(milestoneActions.changeLoadState("RENDER"));
    integrationStore.dispatch(milestoneActions.setOpenForm(false));
    integrationStore.dispatch(milestoneActions.getConnectionsFromServer());
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_UPDATE_CONNECTION, () => {
    integrationStore.dispatch(milestoneActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_REMOVE_CONNECTION, (payload) => {
    const data = JSON.parse(payload) as MilestoneConnectionID;
    integrationStore.dispatch(milestoneActions.removeConnection(data));
});

registerMsgHandler(RESPOND_SYNC_CONNECTION, () => {
    integrationStore.dispatch(milestoneActions.getConnectionsFromServer());
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_SYNC_CONNECTION, () => {
    integrationStore.dispatch(milestoneActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_LIST_CAMERAS, (payload) => {
    const data = JSON.parse(payload) as MilestoneCameraList;
    integrationStore.dispatch(milestoneActions.setCameras(data));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_LIST_CAMERAS, () => {
    integrationStore.dispatch(milestoneActions.setCamerasLoadState({ state: "ERROR" }));
});

registerMsgHandler(RESPOND_SYNC_SELECTED_CAMERAS, () => {
    integrationStore.dispatch(milestoneActions.setCameraSyncState("RENDER"));
    integrationStore.dispatch(milestoneActions.getConnectionsFromServer());
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_SYNC_SELECTED_CAMERAS, () => {
    integrationStore.dispatch(milestoneActions.setCameraSyncState("RENDER"));
});
